import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import integrationRoutes from '../../helpers/routes';
import { IInstallation } from '../../models';
import { installationStates } from '../../static/constants';
import { RootState } from '../rootReducer';
import { getBootstrapAction } from './BootstrapSlice';

export interface IInstallationState {
    installation: IInstallation;
    isSyncing: boolean;
    isFetching: boolean;
    error?: Error;
}

export const initialState: IInstallationState = {
    installation: {
        connectionType: 'unset',
        displayName: 'unset',
        installationId: '',
        integrationType: 'CUSTOM',
        requiresHostname: false,
        signUpUrl: 'unset',
        state: installationStates.CONNECTION_REQUIRED,
    },
    isSyncing: false,
    isFetching: false,
};

const name = 'installation';

const installationSlice = createSlice({
    initialState,
    name,
    reducers: {
        updateInstallation(state, action: PayloadAction<Partial<IInstallation>>) {
            state.installation = {
                ...state.installation,
                ...action.payload,
            };
            state.isSyncing = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBootstrapAction.fulfilled, (state, { payload }) => {
                state.installation = {
                    ...state.installation,
                    ...payload.installation,
                };
                state.installation.requiresHostname =
                    !!payload.installation?.authorizeUrl && payload.installation?.authorizeUrl.includes('%s');
                state.error = undefined;
            })
            .addCase(getBootstrapAction.rejected, (state, { payload }) => {
                state.error = payload;
            });
    },
});

export const { updateInstallation } = installationSlice.actions;

export const installationSelectors = {
    installation: (state: RootState) => state.installation.installation,
    isFetching: (state: RootState) => state.installation.isFetching,
    isSyncing: (state: RootState) => state.installation.isSyncing,
    routes: (state: RootState) => integrationRoutes.get(state.installation.installation.integrationType),
    error: (state: RootState) => state.installation.error,
};

export default installationSlice.reducer;
